import firebase from 'firebase'

const app = firebase.initializeApp( {
  apiKey: "AIzaSyBGmxjBTaDw2U51YSNGZmxQNYH0UbJgAXQ",
  databaseURL: "https://not-engage.firebaseio.com",
  projectId: "not-engage",
});

export const db = app.database();


// WEBPACK FOOTER //
// ./src/config/firebase.js